import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

function BlogListpub2() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const blog_list = useSelector((state) =>
    state?.allapi?.blog_list ? state?.allapi?.blog_list : {}
  );

  useEffect(() => {
    dispatch(allapiAction.getBlogListPub(1));
  }, [dispatch]);

  const recentlisting = blog_list?.docs || [];

  return (
    <div style={{ padding: "30px 15px", background: "#f8f9fa" }}>
      
      {/* Heading */}
      <h2
        style={{
          fontWeight: "700",
          marginBottom: "25px",
          textAlign: "center",
          fontSize: "28px"
        }}
      >
        Our Blog
      </h2>

      {/* Swiper */}
      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        loop={true}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        breakpoints={{
          320: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 }, // 👈 Desktop par 4
        }}
      >
        {recentlisting.map((data, index) => (
          <SwiperSlide key={index}>
            
            <div
              onClick={() => navigate("/blog-details/" + data?.slug)}
              style={{
                background: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                cursor: "pointer",
                transition: "0.3s",
                height: "100%"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 15px 35px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(0,0,0,0.08)";
              }}
            >

              {/* Image */}
              <div style={{ overflow: "hidden" }}>
                <img
                  src={URL?.API_BASE_URL + data?.feature_image}
                  alt={data?.title}
                  style={{
                    width: "100%",
                    height: "220px",          // 👈 fixed height
                    objectFit: "cover",      // 👈 perfect crop
                    transition: "0.4s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.08)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                />
              </div>

              {/* Content */}
              <div style={{ padding: "18px" }}>
                
                <p style={{ fontSize: "14px", color: "#888" }}>
                  {moment(data?.createdAt).format("MMMM DD, YYYY")}
                </p>

                <h4
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    height: "50px",
                    overflow: "hidden"
                  }}
                >
                  {data?.title}
                </h4>

                <p
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    height: "60px",
                    overflow: "hidden"
                  }}
                >
                  {data?.short_description}
                </p>

                <span
                  style={{
                    fontWeight: "600",
                    color: "#007bff"
                  }}
                >
                  Read Full Article →
                </span>

              </div>

            </div>

          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
}

export default BlogListpub2;